import React from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTableCard from '../../Components/Table/DataTableCard';

const SettingsPage = () => {
  const { authUser } = useAuth();

  const initials = (authUser?.fullName || authUser?.email || '?')
    .trim()
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join('');

  return (
    <div className="container-fluid p-0">
      <DataTableCard
        icon="bi-gear-fill"
        title="Pengaturan"
        subtitle="Informasi akun dan aplikasi ILS-SA."
      >
        <div className="row g-4">
          {/* Profile card */}
          <div className="col-lg-5">
            <div className="border rounded-4 p-4 h-100">
              <div className="d-flex align-items-center gap-3 mb-4">
                <div
                  className="bg-primary bg-opacity-10 text-primary fw-bold d-flex align-items-center justify-content-center rounded-circle fs-5"
                  style={{ width: '56px', height: '56px' }}
                >
                  {initials || <i className="bi bi-person-fill"></i>}
                </div>
                <div>
                  <div className="fw-bold text-dark fs-6">
                    {authUser?.fullName || 'Tidak diketahui'}
                  </div>
                  <div className="text-muted extra-small">{authUser?.email || '-'}</div>
                </div>
              </div>

              <dl className="row mb-0">
                <dt className="col-5 text-muted small fw-normal">Peran Sistem</dt>
                <dd className="col-7 mb-3">
                  <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2">
                    {authUser?.systemRole || 'Tidak diketahui'}
                  </span>
                </dd>

                <dt className="col-5 text-muted small fw-normal">ID Karyawan</dt>
                <dd className="col-7 mb-3">
                  <span className="extra-small fw-medium text-muted bg-light px-2 py-1 rounded">
                    #{authUser?.id ?? '-'}
                  </span>
                </dd>

                <dt className="col-5 text-muted small fw-normal">Divisi Terkait</dt>
                <dd className="col-7 mb-0">
                  {authUser?.programId ? (
                    <span className="badge bg-info bg-opacity-10 text-info rounded-pill px-3 py-2">
                      Program #{authUser.programId}
                    </span>
                  ) : (
                    <span className="text-muted extra-small">-</span>
                  )}
                </dd>
              </dl>
            </div>
          </div>

          {/* About / info card */}
          <div className="col-lg-7">
            <div className="border rounded-4 p-4 h-100">
              <h6 className="fw-bold text-dark mb-3">
                <i className="bi bi-info-circle-fill text-primary me-2"></i>
                Tentang Aplikasi
              </h6>
              <ul className="list-unstyled mb-0">
                <li className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted small">Nama Aplikasi</span>
                  <span className="fw-medium text-dark small">
                    ILS Super Admin (ILS-SA)
                  </span>
                </li>
                <li className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted small">Deskripsi</span>
                  <span className="fw-medium text-dark small text-end" style={{ maxWidth: '60%' }}>
                    Panel administrasi terpusat untuk program, batch, karyawan,
                    divisi, dan hak akses.
                  </span>
                </li>
                <li className="d-flex justify-content-between align-items-center py-2 border-bottom">
                  <span className="text-muted small">Lingkungan</span>
                  <span className="fw-medium text-dark small">
                    {process.env.NODE_ENV === 'production' ? 'Production' : 'Development'}
                  </span>
                </li>
                <li className="d-flex justify-content-between align-items-center py-2">
                  <span className="text-muted small">Hak Cipta</span>
                  <span className="fw-medium text-dark small">
                    © {new Date().getFullYear()} Bakrie Center Foundation
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </DataTableCard>
    </div>
  );
};

export default SettingsPage;
